import React, { useState, forwardRef, useCallback, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/joy/Box';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import { styled } from '@mui/system';
import Grid from '@mui/joy/Grid';
import Divider from '@mui/joy/Divider';
import Checkbox from '@mui/joy/Checkbox';

///////////////////mune DropDown
import IconButton from '@mui/joy/IconButton';
import Menu from '@mui/joy/Menu';
import MenuItem from '@mui/joy/MenuItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import MoreVert from '@mui/icons-material/MoreVert';
import MenuButton from '@mui/joy/MenuButton';
import Dropdown from '@mui/joy/Dropdown';


import IconPlus from '../../assets/icons/Plus.svg'
import TrashIcon from '../../assets/icons/trashIcon.svg'
import EditIcon from '../../assets/icons/edit.svg'
import UserIcon from '../../assets/icons/userIcon.svg'

////////////////// Pagintion
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';



////////////////////// Modal
import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';



////////////////// Inputs
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Input from '@mui/joy/Input';

//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';




///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


/////////////////////// API
import { createUsers, getUsers, deleteUsers, getUserDetails, updateUsers } from '../../Api/Users';




const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function ListUsers() {
    const [users, setUsers] = useState([]);
    const [open, setOpen] = useState(false);
    const [userId, setUserId] = useState(null)
    const [rolesAdmin, setRolesAdmin] = useState(0)

    const [actionType, setActionType] = useState(null)

    const [chekedAction, setChekedAction] = useState(false)

    const [valueCheckBox, setValueCheckBox] = useState([])
    const [openModalConfirm, setOpenModalConfirm] = useState(false)

    const [loading, setLoading] = useState(false)
    const [loadingData, setLoadingData] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const [countPage, setCountPage] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);


    let objPagination = {
        page: 1,
    }


    const schema = yup.object({
        name: yup.string().required("هذا الحقل مطلوب"),
        email: yup.string().required("هذا الحقل مطلوب"),
        password: actionType != 'edit' && yup.string().required("هذا الحقل مطلوب"),
        roles: yup.mixed().required("هذا الحقل مطلوب يجب اختيار على الاقل اختيار واحد"),

    })

    const form = useForm({
        defaultValues: {
            name: null,
            email: null,
            password: null,
            roles: []
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const getValueCheckBox = (index, e) => {
        // console.log("getValueCheckBox > ", e.target)
        // console.log("event.target.checked > ", e.target.checked);
        const newInputs = [...valueCheckBox];
        if (e.target.checked) {
            newInputs.push(e.target.value);
            let covertNumbers = newInputs.map(Number)
            setValueCheckBox(covertNumbers)
            setValue('roles', covertNumbers)
        } else {
            let removeValueCheck = valueCheckBox.filter(item => item != e.target.value);
            setValueCheckBox(removeValueCheck)
            setValue('roles', removeValueCheck)
            // console.log('RRRRRRoles >> ', valueCheckBox)
        }
    }

    const getAllUsers = useCallback(async () => {
        setLoadingData(true)
        const res = await getUsers(1, objPagination)
        if (res.data) {
            setLoadingData(false)
            setUsers(res.data)
            setCountPage(res.last_page)
            setCurrentPage(res.current_page)
        }
    }, []);

    const handleChangePagePagintion = async (e, newValuePage) => {
        objPagination.page = newValuePage
        setCurrentPage(newValuePage)
        getAllUsers()
      }

    const removeUserOpenPopUp = (userId) => {
        setUserId(userId)
        setOpenModalConfirm(true)
    }

    const confirmRemoveUser = async () => {
        try {
            const res = await deleteUsers(userId)
            if (res) {
                getAllUsers()
                setUserId(null)
                setLoading(false)
                setOpenModalConfirm(false)
                setMessageAlert(res)
                setOpenAlert(true)
            }
        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpen(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    }
    const getUserDetailsData = async (id) => {
        try {
            setActionType('edit')
            setUserId(id)
            const res = await getUserDetails(id)
            if (res) {
                setRolesAdmin(res.roles.length)
                setValue('name', res.name)
                setValue('email', res.email)
                setValueCheckBox()
                let roleIds = res.roles.map((role) => {
                    return role.role_id
                })
                let covertNumber = roleIds.map(Number)
                // setChekedAction(true)
                setValue('roles', covertNumber)
                setValueCheckBox(covertNumber)
                setOpen(true)
                // console.log(covertNumber , valueCheckBox)
            }
        } catch (error) {
            if (error.response) {
                // setLoading(false)
                // setOpen(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    }

    const openModelCreateUser = () => {
        setValueCheckBox([])
        setRolesAdmin(0)
        setActionType(null)
        setOpen(true)
    }

    const submitNewUser = async (data) => {
        if(valueCheckBox.length == 0) {
            setMessageAlertError('يجب تحديد حقل واحد على الاقل')
            setOpenAlertError(true)
        }else{
            setLoading(true)

            try {
                if (actionType == 'edit') {
                    const res = await updateUsers(userId, data)
                    if (res) {
                        getAllUsers()
                        setActionType(null)
                        setLoading(false)
                        setOpen(false)
                        setMessageAlert('تم تعديل المستخدم بنجاح')
                        setOpenAlert(true)
                    }
                } else {
                    const res = await createUsers(data)
                    if (res) {
                        getAllUsers()
                        setLoading(false)
                        setOpen(false)
                        setMessageAlert('تم اضافة المستخدم بنجاح')
                        setOpenAlert(true)
                    }
    
                }
            } catch (error) {
                if (error.response) {
                    setLoading(false)
                    setOpen(false)
                    setOpenAlertError(true)
                    setMessageAlertError(error.response.data.message)
                }
            }
        }
    }

    useEffect(() => {
        getAllUsers();
    }, [getAllUsers])

    return (
        <>
            {/* Alert Message */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>

            {/* Modal PopUp Delete */}
            <Modal open={openModalConfirm} onClose={() => setOpenModalConfirm(false)}>
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderRadius: 0,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                        direction: 'rtl'
                    })}
                >
                    <Typography id="nested-modal-title" level="h2">
                        هل انت متاكد من حذف المستخدم ؟
                    </Typography>
                    <Typography id="nested-modal-description" textColor="text.tertiary">
                        لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف المستخدم بشكل دائم وإزالة بياناتك من خوادمنا.
                    </Typography>
                    <Box
                        sx={{
                            mt: 1,
                            display: 'flex',
                            gap: 1,
                            flexDirection: { xs: 'column', sm: 'row-reverse' },
                        }}
                    >
                        <Button
                            variant="solid"
                            color="primary"
                            onClick={() => confirmRemoveUser()}
                            loading={loading}
                        >
                            تأكيد
                        </Button>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => setOpenModalConfirm(false)}
                        >
                            الغاء
                        </Button>
                    </Box>
                </ModalDialog>
            </Modal>


            {/* Modal Create New User*/}
            <Modal open={open} onClose={() => setOpen(false)}>
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderRadius: 0,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                    })}
                >
                    <Typography id="nested-modal-title" level="h2" sx={{ direction: 'rtl' }}>
                        {actionType == 'edit' ? 'تعديل بيانات المستخدم' : 'إضافة مسنخدم جديد'}
                    </Typography>
                    <form onSubmit={handleSubmit(submitNewUser)}>
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            sx={{ width: '800px', direction: 'rtl' }}
                            alignContent='stretch'
                        >
                            <Grid xs={5.5}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '30px' }}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <FormLabel sx={{ color: '#434448', fontSize: '14px' }}>اسم المستخدم</FormLabel>
                                        <Input
                                            type="text"
                                            placeholder="اسم المستخدم"
                                            sx={{ borderRadius: '20px', fontSize: '14px' }}
                                            {...register('name')}
                                        />
                                        {errors.name &&
                                            <Typography
                                                color="danger"
                                                level="body-xs"
                                                variant="plain"
                                            >{errors.name?.message}</Typography>
                                        }

                                    </FormControl>
                                    <FormControl sx={{ width: '100%' }}>
                                        <FormLabel sx={{ color: '#434448', fontSize: '14px' }}>البريد الإلكتروني</FormLabel>
                                        <Input
                                            type="email"
                                            placeholder="البريد الإلكتروني"
                                            sx={{ borderRadius: '20px', fontSize: '14px' }}
                                            {...register('email')}
                                        />
                                        {errors.email &&
                                            <Typography
                                                color="danger"
                                                level="body-xs"
                                                variant="plain"
                                            >{errors.email?.message}</Typography>
                                        }
                                    </FormControl>
                                    <FormControl sx={{ width: '100%' }}>
                                        <FormLabel sx={{ color: '#434448', fontSize: '14px' }}>كلمة المرور</FormLabel>
                                        <Input
                                            type="password"
                                            placeholder="كلمة المرور"
                                            sx={{ borderRadius: '20px', fontSize: '14px' }}
                                            {...register('password')}
                                        />
                                        {errors.password &&
                                            <Typography
                                                color="danger"
                                                level="body-xs"
                                                variant="plain"
                                            >{errors.password?.message}</Typography>
                                        }
                                    </FormControl>
                                </Box>
                            </Grid>
                            <Grid xs={1} container justifyContent="center" >
                                <Divider orientation="vertical" sx={{ height: '100%' }} />
                            </Grid>
                            <Grid xs={5.5}>
                                <Typography level="title-lg">
                                    الصلاحيات{' '}
                                    <Typography
                                        level="title-lg"
                                        textColor="var(--joy-palette-success-plainColor)"
                                        fontFamily="monospace"
                                        sx={{ opacity: '50%' }}
                                    >
                                        {'الصلاحيات النشطة' + ' 5 / ' + rolesAdmin}
                                    </Typography>
                                </Typography>
                                <Box sx={{ direction: 'ltr', marginTop: '30px', display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'space-between' }}>
                                    <Checkbox value={1} onChange={(e) => getValueCheckBox(1, e)} label="إضافة اعلانات" checked={valueCheckBox.includes(1) ? true : false} />
                                    <Checkbox value={2} onChange={(e) => getValueCheckBox(2, e)} label="تعديل اعلانات" checked={valueCheckBox.includes(2) ? true : false} />
                                    <Checkbox value={3} onChange={(e) => getValueCheckBox(3, e)} label="اضافة موديلات جديدة" checked={valueCheckBox.includes(3) ? true : false} />
                                    <Checkbox value={4} onChange={(e) => getValueCheckBox(4, e)} label="تعديل موديلات" checked={valueCheckBox.includes(4) ? true : false} />
                                    <Checkbox value={5} onChange={(e) => getValueCheckBox(5, e)} label="رؤية التقارير المالية" checked={valueCheckBox.includes(5) ? true : false} />
                                </Box>
                                {errors.roles &&
                                    <Typography
                                        color="danger"
                                        level="body-xs"
                                        variant="plain"
                                    >{errors.roles?.message}</Typography>
                                }
                            </Grid>
                        </Grid>
                        <Box
                            sx={{
                                margin: '50px 0',
                                display: 'flex',
                                gap: 1,
                                flexDirection: { xs: 'column', sm: 'row-reverse' },
                                justifyContent: 'start'

                            }}
                        >
                            <Button
                                // variant="outlined"
                                onClick={() => setOpen(false)}
                                sx={{ backgroundColor: '#757778', width: '20%', height: '50px' }}
                            >
                                الغاء
                            </Button>
                            <Button
                                variant="solid"
                                type='submit'
                                sx={{ backgroundColor: '#3E64F4', width: '20%', height: '50px' }}
                                // onClick={openNewUser}
                                loading={loading}
                            >
                                {actionType == 'edit' ? 'تعديل المستخدم' : 'إضافة مسنخدم جديد'}
                            </Button>

                        </Box>

                    </form>

                </ModalDialog>
            </Modal>
            {loadingData ? (
                <LinearProgress />
            ) : false}

            <Box
                sx={{
                    width: '100%',
                    maxWidth: '100%',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: 2,
                    // justifyContent: 'stretch',
                    alignItems: 'stretch'
                }}
            >
                {users.map((user) => {
                    return (
                        <Card variant="soft" sx={{ backgroundColor: '#F7F9FB', position: 'relative', border: '1px solid #B6B6B6' }}>
                            <Box component="section" sx={{ width: '16px', height: '16px' }}>
                                <Dropdown>
                                    <MenuButton
                                        slots={{ root: IconButton }}
                                        slotProps={{ root: { variant: 'plan', color: 'plan' } }}
                                        sx={{ backgroundColor: '#3E64F4', borderRadius: '50%', color: '#FFF', scale: '0.7', position: 'absolute', left: '10px', top: '10px' }}
                                    >
                                        <MoreVert />
                                    </MenuButton>
                                    <Menu placement="bottom-end">
                                        <MenuItem sx={{ color: '#434448' }} onClick={() => getUserDetailsData(user.id)}>
                                            <ListItemDecorator>
                                                <img src={EditIcon} alt='icon' />
                                            </ListItemDecorator>{' '}
                                            تعديل
                                        </MenuItem>
                                        <MenuItem sx={{ color: '#434448' }} onClick={() => removeUserOpenPopUp(user.id)}>
                                            <ListItemDecorator sx={{ color: 'inherit' }}>
                                                <img src={TrashIcon} alt='icon' />
                                            </ListItemDecorator>{' '}
                                            حذف
                                        </MenuItem>
                                    </Menu>
                                </Dropdown>
                            </Box>
                            <CardContent>
                                <img src={UserIcon} className='iconUserCard' alt='icon' />
                                <Typography level="h3" sx={{ fontSize: '16px', color: '#515151' }}>{user.name ? user.name : "لا يوجد اسم"}</Typography>
                                <Typography level="p" sx={{ fontSize: '14px', color: '#7F7F89' }}>الصلاحيات النشطة {user.roles.length}/5</Typography>
                            </CardContent>
                        </Card>
                    )
                })}

                <Card variant="soft" sx={{ backgroundColor: '#FFF', cursor: 'pointer' }}>
                    <Box onClick={openModelCreateUser} sx={{ paddingTop: '9%' }}>
                        <CardContent sx={{ textAlign: 'center' }}>
                            <img className='plusIconCreateUser' src={IconPlus} alt='add icon' />
                            <Typography level="h3" sx={{ fontSize: '14px', color: '#3E64F4' }}>اضافة مستخدم جديد</Typography>
                        </CardContent>
                    </Box>
                </Card>
            </Box>
            <Stack spacing={2} alignItems='center' mt='30px'>
                <Pagination count={countPage} page={currentPage} color="primary" sx={{ margin: 'auto', direction: 'ltr' }} onChange={handleChangePagePagintion} />
            </Stack>
        </>

    );
}